import React, { useState, useEffect, useRef } from "react";
import NoAccess from "../../../assets/img/NoAccess.png";
import OldUpdateProduct from "./components/ProductList/UpdateProduct/OldUpdateProduct";
import NewUpdateProduct from "./components/ProductList/UpdateProduct/NewUpdateProduct";
const UpdateProduct = ({ authrztn }) => {
  const [displayComponent] = useState("NEW");

  return (
    <>
      <div className="h-100 w-100 border bg-white custom-container">
        {authrztn.includes("ProductList-Edit") ? (
          <>
            {" "}
            {displayComponent === "OLD" ? (
              <OldUpdateProduct authrztn={authrztn} />
            ) : displayComponent === "NEW" ? (
              <NewUpdateProduct authrztn={authrztn} />
            ) : null}
          </>
        ) : (
          <div className="no-access">
            <img src={NoAccess} alt="NoAccess" className="no-access-img" />
            <h3>You don't have access to this function.</h3>
          </div>
        )}
      </div>
    </>
  );
};

export default UpdateProduct;
